import { FC, useState } from 'react';
import { taskProps, tenderDataProps } from '../../../pages/TenderViewPage/types';
import pendingIcon from '../../../assets/panding-circle.svg';
import SiteVisitIcon from '../../../assets/SiteVisitIcon.svg';
import done from '../../../assets/Done, Check.svg';
import calendar from '../../../assets/calendar-chedule.svg';
import moment from 'moment';
import { SiteVisitModal } from './SiteVisitModal';
import { ClockIcon } from '../../Icons/ClockIcon';
import editIcon from '../../../assets/editAdminIcon.svg';

interface DefineSiteVisitDateProps {
    data: tenderDataProps;
    role: string | null;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DefineSiteVisitDate: FC<DefineSiteVisitDateProps> = ({ data, role, setTrigger }) => {
    const [openModal, setOpenModal] = useState(false);

    const capitalize = (value?: string) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : '');

    return (
        <>
            {data?.phase_tasks.length &&
                data?.phase_tasks.map((elem: taskProps) => {
                    if (elem.action === 'define_site_visit_date') {
                        if (role !== 'school_user') {
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete green
                            `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SiteVisitIcon} />
                                                {elem?.name}
                                            </div>
                                        </div>

                                        <div className="task-complete__info-wrap">
                                            <div className="task-complete__wrap">
                                                <div className="task-complete__name">My slot(s)</div>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                {elem.slots?.map((slot: any) => {
                                                    return (
                                                        <div className="slots__wrapper site-visit">
                                                            <div className="slots__block">
                                                                <div className="slots__name">Date</div>
                                                                <div className="slots__value">
                                                                    <img src={calendar} />
                                                                    {moment(slot?.date)?.format('YYYY-MM-DD')}
                                                                </div>
                                                            </div>
                                                            <div className="slots__block">
                                                                <div className="slots__name">Time</div>
                                                                <div className="slots__value">
                                                                    <ClockIcon
                                                                        fill="#001965"
                                                                        style={{ margin: '0 4px 0 0' }}
                                                                    />
                                                                    {slot?.time === 'no_preference'
                                                                        ? 'No preference'
                                                                        : capitalize(slot?.time)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su') {
                                return (
                                    <div key={elem.id} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={SiteVisitIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>
                                        <div className="task-complete__btn" onClick={() => setOpenModal(true)}>
                                            Specify
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'completed' || elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            elem.status === 'completed' ? 'green' : ''
                                        }
                            `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SiteVisitIcon} />
                                                {elem?.name}
                                            </div>
                                            {elem.status === 'completed' ? (
                                                <div className="task-complete__title-row">
                                                    <div className="task-complete__approved-active">
                                                        <img src={done} />
                                                        Completed
                                                    </div>
                                                </div>
                                            ) : elem.status === 'need_approve_tr' ? (
                                                <div className="task__pending" key={elem.id}>
                                                    <img src={pendingIcon} />
                                                    Pending
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </div>

                                        <div className="task-complete__info-wrap">
                                            <div className="task-complete__wrap">
                                                <div className="task-complete__name">My slot(s)</div>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                {elem.slots?.map((slot: any) => {
                                                    return (
                                                        <div className="slots__wrapper site-visit">
                                                            <div className="slots__block">
                                                                <div className="slots__name">Date</div>
                                                                <div className="slots__value">
                                                                    <img src={calendar} />
                                                                    {moment(slot?.date)?.format('YYYY-MM-DD')}
                                                                </div>
                                                            </div>
                                                            <div className="slots__block">
                                                                <div className="slots__name">Time</div>
                                                                <div className="slots__value">
                                                                    <ClockIcon
                                                                        fill="#001965"
                                                                        style={{ margin: '0 4px 0 0' }}
                                                                    />
                                                                    {slot?.time === 'no_preference'
                                                                        ? 'No preference'
                                                                        : capitalize(slot?.time)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            {elem.status === 'completed' && (
                                                <img
                                                    src={editIcon}
                                                    className="task-complete__edit"
                                                    onClick={() => setOpenModal(true)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }
                })}

            {openModal && (
                <SiteVisitModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    tenderData={data}
                    setTrigger={setTrigger}
                />
            )}
        </>
    );
};
